export default {
    termsTitle: '',
    termsContent: '',
    categories: [],
    pages: []
}